import { render } from "./Viewer.vue?vue&type=template&id=0e865707"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"
script.render = render

export default script